module.exports = __webpack_public_path__ + "img/withdraw4-1.0571eb3f.jpg";